var map = {
	"./ag_icon.png": 37602,
	"./bti_icon.png": 57313,
	"./cmd368_icon.png": 94057,
	"./csg-fishing_icon.png": 36676,
	"./dg_icon.png": 26315,
	"./ds_icon.png": 69071,
	"./evolution_icon.png": 83009,
	"./haba_icon.png": 36424,
	"./ibc2_icon.png": 67032,
	"./jili_icon.png": 24768,
	"./pgsoft_icon.png": 39295,
	"./playtech_icon.png": 62856,
	"./prag_icon.png": 53380,
	"./pt_icon.png": 53042,
	"./sa_icon.png": 17002,
	"./sbobet_icon.png": 86595,
	"./sg_icon.png": 87188,
	"./td_icon.png": 88182,
	"./v8_icon.png": 6168,
	"./wm_icon.png": 9250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72957;